// extracted by mini-css-extract-plugin
module.exports = {"ranking":"StarRanking_ranking__ukzRS"};